import { styled } from '@mui/material/styles'
import { Box } from '@mui/material'
import { MuiButton } from '../../../../../components'

const RIGHT_CONTENT = '220px'

export const GraphContentWrapper = styled(Box)(`
  width: 100%;
  display: flex;
  flex-direction: column;
  & .contentText {
    background:#fff;
  }

  &.showRowLevel2 {
    border-bottom: 10px #fff solid;
    position:relative;
  }
  &.showRowLevel2 .graphRowDetails {
    background: #fff;
  }
  &.showRowLevel2 .graphRowDetails:empty { display: none; }
  &.showRowLevel2 .contentText {
    border-bottom:0 !important;
  }
  &.showRowLevel2 > div:last-child > div {
    border-bottom:0 !important;
    position: relative;
  }

  &.showRowLevel2 .graphRowDetails button {
    transform: rotate(180deg);
    & svg path {
        fill: #095BBD;
    }
  }
`)

export const IconButtonWrapper = styled(MuiButton)(`
    position: absolute;
    right: 8px;
    top: 0px;
`)

export const GraphContent = styled(Box)(`
    width: 100%;
    display: flex;
    &.brandImageryRowProgression.brandImageryRowProgression .list {
        margin-left:0;
        background: #fff;
        border: 0;
        padding-top:5px;
    }
    & .level2 {
        position:relative;
    }
`)

export const GraphRow = styled(Box)(`
    display: flex;
    justify-content: center;
    flex-direction: column;
    width: 100%;
    min-height: 50px;
`)

export const GraphRowDetails = styled(Box)(`
    display: flex;
    width: 35px;
    justify-content: center;
    align-items: center;
    height: 30px;

    & > button {
        position: absolute;
        top: 0;
        right: 0;
        height:35px;
    }
`)

export const GraphContentRow = styled(Box)(`
    position:relative;
    font-size: 14px;
    font-weight: 600;
    line-height: 18px;
    display:flex;
    width:100%;
    background: #fff;
    padding:5px 0;
    & p {
        padding-right:10px;
    }
    & p.percent {
        font-weight: 600;
    }
`)

export const TabCarouselWrapper = styled(Box)(
  (props) => `
	display: flex;
    background:#FFF;
    overflow:hidden;
    width:100%;

    & b { 
        background: #F2F8FF;
        color: #095BBD;
        border-radius: 4px;
        padding: 0 3px;
        margin-left: 4px;
    }
`)

export const GraphLevel3 = styled(Box)(`
    border: 1px #D8D8D6 solid;
    padding: 12px;
    background: #fff;

    .chartLegendWrapper {
        padding:0;
        margin:0;
    }
`)

export const TabCarousel = styled(Box)(`
	display: flex;
	border: 1px #fff solid;
    background: #F3F3F3;
	width: 100%;
    padding: 10px;
    overflow: auto;
    
    & .slider > div {
        padding: 0 5px;
    }
    & p {
        padding: 0 10px;
        margin: 0;
        height: 30px;
        cursor: pointer;
        line-height: 30px;
        font-size: 14px;
        display: inline-block;
        white-space: nowrap;
    }
    & p.active {
        font-weight: 600;
        background:#FFF;
    }
    & .slick-slider {
        width:100%;
        height: 30px;
        display:flex;
        align-items:center;
    }
    & .slick-slider button {
        width:30px;
        height:20px;
        margin-top: 20px;
        position: static;
        top:0;
        left:0;
        right:0;
    }
    & .slick-slider svg {
        width:30px;
        height:20px;
    }
    & .slick-slider .slick-list {
        width:calc(100% - 60px);
    }
`)
